module.exports = citeproc;


//////////////////
// WEBPACK FOOTER
// external "citeproc"
// module id = 718
// module chunks = 6